<template>
  <div class="main-body">
    <div class="header">护士人脸</div>
    <div class="out">

      <div class="search2">

        <div style="float:right;">

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>
        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="userName" label="名称"></el-table-column>

        <el-table-column label="头像" width="300">
          <template slot-scope="scope">
            <!--            <img :src="'data:image/jpeg;base64,'+scope.row.faceImg" alt="图片未上传" width="100"/>-->

            <img :src="imgUrl+scope.row.imgPath" alt="图片未上传" width="100"/>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

  </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",
  data(){
    return{

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,
      imgUrl:this.$imgUrl,


      arr_ins:[],
      institutionCode: '',

    }
  },
  created(){
    this.getIns();
    this.th = this.$store.state.tableHeight;
  },
  components:{

  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:1,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    getCreateTime(row) {
      return timefilters(row.createTime);
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'UserFace/GovPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          userType:8,
          userName:'',
          institutionCode:this.institutionCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;


        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },



  }
}
</script>

<style scoped>

</style>
